import React from 'react';
import useStore from '@data/state/zustand';

export interface DocumentProps {
    children?: any;
    setHeaderHeight?: Function;
    setFooterHeight?: Function;
}

const DocumentFooter = (props: DocumentProps) => {
    const { setFooterHeight, children } = props;
    const imgRef = React.useRef<HTMLImageElement>(null);

    const otherSettings = useStore((appState: any) => appState.otherSettings);

    const getImageUrlFromDocumentFooterInfo = React.useCallback(() => {
        const documentFooterInfo = otherSettings?.documentFooter || '';
        const regex = /<img\s+[^>]*src="([^"]*)"/;
        const match = documentFooterInfo.match(regex);
        return match ? match[1] : '';
    }, [otherSettings]);

    const imageUrl = getImageUrlFromDocumentFooterInfo();

    React.useEffect(() => {
        if (imageUrl === '') {
            if (setFooterHeight) {
                setFooterHeight(60);
            }
        } else {
            const loadImage = new Image();
            loadImage.src = imageUrl;
            loadImage.onload = () => {
                const coefficient = loadImage.width / 900;
                const height = loadImage.height / coefficient;
                console.log('📐 Footer image loaded:', {
                    originalWidth: loadImage.width,
                    originalHeight: loadImage.height,
                    coefficient,
                    calculatedHeight: height
                });
                if (setFooterHeight) {
                    setFooterHeight(height);
                }
            };
            loadImage.onerror = () => {
                console.error('❌ Footer image failed to load:', imageUrl);
                if (setFooterHeight) {
                    setFooterHeight(60);
                }
            };
        }
    }, [setFooterHeight, imageUrl]);

    // Ako nema slike, renderiraš prazan footer
    if (!imageUrl) {
        return (
            <div className="text-center border-top" style={{ marginBottom: '12px' }}>
                {children}
            </div>
        );
    }

    // DIREKTNO RENDERIRANJE SLIKE - bez <small> wrappera, sa FIKSNOM ŠIRINOM
    return (
        <div className="text-center border-top">
            <img 
                ref={imgRef}
                src={imageUrl} 
                alt="Footer"
                style={{ 
                    width: '900px',  // FIKSNA ŠIRINA umjesto 100%
                    maxWidth: '100%',
                    height: 'auto',
                    display: 'block',
                    margin: '0 auto'
                }}
            />
            {children}
        </div>
    );
};

export default DocumentFooter;